import React, { useState } from 'react';
import Wrapper from './styles';
import { stores } from '../../../../stores';
import Svg from '../../../svg/Svg';
import { SwipeableDrawer } from '@mui/material';
import SportPhoneSelectSportSidebar from '../select-sport-sidebar/SportPhoneSelectSportSidebar';
import { isFeatureAvailable } from '../../../../services/feature';
import UiModal from '../../../ui/modal/UiModal';
import SportBetslipWrapper from '../../betslip-wrapper/SportBetslipWrapper';
import SportTicketList from '../../ticket/list/SportTicketList';
import isEmpty from 'lodash/isEmpty';
import SportParlayCardBetslip from '../../parlay-card/betslip/SportParlayCardBetslip';
import { isB2B, isBYOD } from '../../../../services/environment';
import { isMobileApp } from '../../../../services/mobile-app';
import PushToAppInstall from '../../../push-to-app-install/PushToAppInstall';
import ComboCardsBetslip from '../../../combo-cards/betslip/ComboCardsBetslip';
import { useStore } from '../../../../hooks/useStore';
import { FEATURE } from '../../../../services/types';
import { useContestPreSelectionState } from '../../../../hooks/contests';
import SportContestsBetslip from '../../contests/betslip/SportContestsBetslip';
import { getRoute, isActiveRoute } from '../../../../services/router';

export default function SportPhoneNavigation() {
    const [betSlipMarketIdToOutcomeId] = useStore(stores.sports.betSlipMarketIdToOutcomeId);
    const [parlayCardBetSlipMarketIdToOutcomeIds] = useStore(stores.sports.parlayCard.betSlipMarketIdToOutcomeIds);
    const [cardsInBetslip] = useStore(stores.sports.comboCard.cardsInBetslip);
    const numberOfBets = Object.values(betSlipMarketIdToOutcomeId).length;
    const numberOfParlayBets = Object.values(parlayCardBetSlipMarketIdToOutcomeIds).flat().length;
    const numberOfComboCardBets = cardsInBetslip.length;
    const [isSportSideMenuOpen, setIsSportSideMenuOpen] = useStore(stores.sports.isSportSideMenuOpen);
    const isLayoutB = !isFeatureAvailable(FEATURE.SPORT_LAYOUT_A);
    const [isAuthenticated] = useStore(stores.isAuthenticated);
    const [isBetslipOpen, setIsBetslipOpen] = useStore(stores.isBetslipOpen);
    const [isContestBetslipOpen, setIsContestBetslipOpen] = useStore(stores.isContestBetslipOpen);
    const [isBetHistoryOpen, setIsBetHistoryOpen] = useStore(stores.isBetHistoryOpen);
    const isBetslipNotEmpty = !isEmpty(betSlipMarketIdToOutcomeId);
    const isParlayBetslipEmpty = isEmpty(parlayCardBetSlipMarketIdToOutcomeIds);
    const isComboCardBetslipEmpty = isEmpty(cardsInBetslip);
    const [isParlayBetslipOpen, setIsParlayBetslipOpen] = useStore(stores.isParlayBetslipOpen);
    const [isComboCardBetslipOpen, setIsComboCardBetslipOpen] = useStore(
        stores.sports.comboCard.isComboCardBetslipOpen,
    );
    const isEdgeTierChatAvailable = isFeatureAvailable(FEATURE.EDGE_TIER);
    const isBetHistoryTabVisible = isAuthenticated && numberOfBets === 0 && numberOfParlayBets === 0 && !isB2B();
    const [isAppModalOpen, setIsAppModalOpen] = useState(false);
    const { getSelections } = useContestPreSelectionState();
    const isContestsRoute = isActiveRoute(getRoute('sport.contests'), false);
    const isContestBetslipEmpty = getSelections().length === 0;

    function showPushToDownloadAppModal() {
        return isFeatureAvailable(FEATURE.PUSH_TO_APP_INSTALL) && !isMobileApp() && !isBYOD();
    }

    function showBetslip() {
        if (isContestsRoute && !isContestBetslipEmpty) {
            setIsContestBetslipOpen(true);
            return;
        }
        if (!isComboCardBetslipEmpty) {
            setIsComboCardBetslipOpen(true);
            return;
        }
        if (isBetslipNotEmpty || isParlayBetslipEmpty) {
            setIsBetslipOpen(true);
        } else {
            setIsParlayBetslipOpen(true);
        }
    }

    function onBetslipClickHandler() {
        if (showPushToDownloadAppModal()) {
            setIsAppModalOpen(true);
        } else {
            showBetslip();
        }
    }

    function toggleSportSideMenuOpen() {
        setIsSportSideMenuOpen(!isSportSideMenuOpen);
    }

    function getBetCount() {
        if (!isComboCardBetslipEmpty) {
            return numberOfComboCardBets;
        } else if (isBetslipNotEmpty) {
            return numberOfBets;
        } else {
            return numberOfParlayBets;
        }
    }

    return (
        <Wrapper $withChatBubble={isEdgeTierChatAvailable}>
            {isBetHistoryTabVisible ? (
                <div onClick={() => setIsBetHistoryOpen(true)} className="safe-area">
                    <div className="back-link">
                        <Svg icon="bethistory-ico" size={0.95} />
                    </div>
                </div>
            ) : isContestsRoute && !isContestBetslipEmpty ? (
                <div onClick={onBetslipClickHandler} className="safe-area">
                    <div className="betslip-link">
                        <div className="bets-count">{getSelections().length}</div>
                    </div>
                </div>
            ) : (
                (numberOfBets !== 0 || !isParlayBetslipEmpty) &&
                !isContestsRoute && (
                    <div onClick={onBetslipClickHandler} className="safe-area">
                        <div className="betslip-link">
                            <div className="bets-count">{getBetCount()}</div>
                        </div>
                    </div>
                )
            )}

            <div className="safe-area" onClick={() => stores.sports.isSportSideMenuOpen.set(!isSportSideMenuOpen)}>
                <div className="sport-link">
                    <Svg icon="select-sport-ico" size={0.95} />
                </div>
            </div>
            <SwipeableDrawer
                disableEnforceFocus
                open={isSportSideMenuOpen}
                onOpen={toggleSportSideMenuOpen}
                onClose={toggleSportSideMenuOpen}
                anchor={isLayoutB ? 'left' : 'right'}
                disableDiscovery={true}
            >
                <SportPhoneSelectSportSidebar />
            </SwipeableDrawer>

            <UiModal
                open={isBetslipOpen}
                onClose={() => setIsBetslipOpen(false)}
                onOpen={() => setIsBetslipOpen(true)}
                mode="drawer"
            >
                <div className="betslip-box">
                    <SportBetslipWrapper />
                </div>
            </UiModal>

            <UiModal
                open={isParlayBetslipOpen}
                onClose={() => setIsParlayBetslipOpen(false)}
                onOpen={() => setIsParlayBetslipOpen(true)}
                mode="drawer"
            >
                <div className="betslip-box">
                    <SportParlayCardBetslip />
                </div>
            </UiModal>

            <UiModal
                open={isComboCardBetslipOpen}
                onClose={() => setIsComboCardBetslipOpen(false)}
                onOpen={() => setIsComboCardBetslipOpen(true)}
                mode="drawer"
            >
                <div className="betslip-box">
                    <ComboCardsBetslip />
                </div>
            </UiModal>

            <UiModal
                open={isContestBetslipOpen}
                onClose={() => setIsContestBetslipOpen(false)}
                onOpen={() => setIsContestBetslipOpen(true)}
                mode="drawer"
            >
                <div className="betslip-box">
                    <SportContestsBetslip />
                </div>
            </UiModal>

            <UiModal
                open={isBetHistoryOpen}
                onClose={() => setIsBetHistoryOpen(false)}
                onOpen={() => setIsBetHistoryOpen(true)}
                mode="drawer"
            >
                <div className="tickets-box">
                    <SportTicketList className="tickets-list" />
                </div>
            </UiModal>

            <UiModal
                open={isAppModalOpen}
                onClose={() => setIsAppModalOpen(false)}
                onOpen={() => setIsAppModalOpen(true)}
            >
                <PushToAppInstall onClose={() => setIsAppModalOpen(false)} />
            </UiModal>
        </Wrapper>
    );
}
